module.exports = __webpack_public_path__ + "img/D201409_2.26235fcf.jpg";